<template lang="pug">
.v-product-slider.product-slider(v-if="block" ref="goal")
	.product-slider__container.container
		.product-slider__wrapper
			.product-slider__title-wrapper
				.product-slider__title-main
					.product-slider__title(v-if="block.title") {{block.title}}
					a.product-slider__title-button(v-if="block.button"
							:href="block.button.link")
						| {{block.button.text}}
			.product-slider__cars-wrapper(v-if="block.items && block.items.length && isLoaded")
				.product-slider__slider-wrapper
					button.product-slider__arrow.product-slider__arrow--prev(type="button" ref="car-prev" aria-label="Предыдущий слайд")
						v-svg-icon.product-slider__arrow-icon(icon="slide-left")
						v-svg-icon.product-slider__arrow-bg(icon="slide-left-bg")
					button.product-slider__arrow.product-slider__arrow--next(type="button" ref="car-next" aria-label="Следующий слайд")
						v-svg-icon.product-slider__arrow-icon(icon="slide-right")
						v-svg-icon.product-slider__arrow-bg(icon="slide-right-bg")
					v-swiper-slider.product-slider__slider(:options="options"
							:navigation="navigation"
							@swiper="onSwiper")
						swiper-slide.product-slider__slide(v-for="(item, itemIndex) in block.items" :key="itemIndex")
							.product-slider__product-wrap
								.product-slider__favorite-action
									v-favorite-action(:id="item.id" :name="item.name" :model="item.model")
								v-product.product-slider__product(:product="item")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import loadMixin from './mixins/v-load-mixin.vue';
import breakpoints from "../scripts/breakpoints.js"
import {SwiperSlide} from "swiper/vue";

export default {
	mixins: [
		sourceMixin,
		loadMixin
	],

	components: {
		SwiperSlide,
	},

	data() {
		return {
			block: null,
			options: {
				slidesPerView: 'auto',
				loop: true,
				breakpoints: {
					[breakpoints['sm-max']]: {
						spaceBetween: 20,
						slidesPerGroup: 3
					},
					[breakpoints['4xs-min']]: {
						spaceBetween: 6,
						slidesPerGroup: 1
					}
				},
			},
			allowTouchMove: true,
			pagination: {
				clickable: false,
			},
			navigation: false,
			observerOptions: {
				root: null,
				rootMargin: '0px',
				threshold: 0
			}
		};
	},

	methods: {
		onSwiper() {
			this.navigation = {
				prevEl: this.$refs["car-prev"],
				nextEl: this.$refs["car-next"],
			};
		},

		dataSet(data) {
			this.block = data;
		}
	}
};
</script>